import api from './api';

const actualiteService = {
  // Routes publiques
  getAll: (page = 1) => {
    return api.get(`/actualites?page=${page}`);
  },

  getRecent: () => {
    return api.get('/actualites/recent');
  },

  getBySlug: (slug) => {
    return api.get(`/actualites/${slug}`);
  },

  // Routes admin
  admin: {
    getAll: (params = {}) => {
      return api.get('/admin/actualites', { params });
    },

    getById: (id) => {
      return api.get(`/admin/actualites/${id}`);
    },

    create: (data) => {
      return api.post('/admin/actualites', data);
    },

    update: (id, data) => {
      // Si c'est un FormData, utiliser POST avec _method=PUT pour Laravel
      if (data instanceof FormData) {
        return api.post(`/admin/actualites/${id}`, data, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
      }
      return api.put(`/admin/actualites/${id}`, data);
    },

    delete: (id) => {
      return api.delete(`/admin/actualites/${id}`);
    },

    getStatistiques: () => {
      return api.get('/admin/actualites/statistiques');
    }
  }
};

export default actualiteService;
